import script from "./VAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./VAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./VAvatar.vue?vue&type=style&index=0&id=1ecc74cf&lang=sass"

const __exports__ = script;

export default __exports__